import React, { Component } from 'react'
import { connect } from 'react-redux';

import {
  BookOutlined,
  CloseCircleFilled,
  DeleteFilled,
  PercentageOutlined,
  PlusCircleOutlined,
  PrinterOutlined,
  SaveFilled,
  PlusOutlined,
  CloseOutlined
} from '@ant-design/icons';

import {
  Input,
  InputNumber,
  Tooltip,
  Row,
  Col,
  Button,
  Table,
  Modal,
  DatePicker,
  Divider,
  message,
  Form
} from 'antd';

import FormItem from 'antd/lib/form/FormItem';
import { withTranslation, Trans } from 'react-i18next';
import DisplayAmount from '../common/DisplayAmount';
import moment from 'moment-business-days';
import { dateFormat, apiDateFormat } from '../../lib/DateFormat';
import { getRolename } from '../../lib/AuthUtils'
import Link from 'next/link'

import {
  setShowEstimate,
  getCurrentQuotation,
  addItemQuotationFromCode,
  changeItemQuantityQuotation,
  removeItemFromQuotation,
  setDataToQuotation,
  saveQuotation,
  cancelQuotation,
  newQuotation,
  getProductByCode
} from '../../actions'
import DisplayStock from "../common/DisplayStock";

const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 7 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 17 },
  },
};

class CatalogEstimateForm extends Component {
  constructor(props) {
    super(props);

    const { auth } = this.props
    const roleName = getRolename(auth)

    this.state = {
      itemCode: null,
      isClient: (roleName === 'cliente') ? true : false,
      canItem:1
    }

    this.columns = [
      {
        title: false,
        dataIndex: '',
        key: 'icons',
        render: (tex, record) => (
            <table className="cart-item-table">
              {record.index === 0 && (
                  <thead>
                  <tr className="text-center">
                    <th>
                      <Trans>Code</Trans>
                    </th>
                    <th>
                      <Trans>Stock</Trans>
                    </th>
                    <th>
                      <Trans>Cant.</Trans>
                    </th>
                    <th>Detalle</th>
                    <th>
                      <Trans>Price</Trans>
                    </th>
                    <th/>
                  </tr>
                  </thead>
              )}
              <tbody>
              <tr className="text-center">
                <td width={60}>
                <div className="catalog-item-card-title" onClick={() => this.showDetail({ ...record })}>
                    <p><a>{record.codigodearticulo}</a></p>
                  </div>
                </td>
                <td width={60}>
                  <DisplayStock product={record} />
                </td>
                <td width={80}>
                  <InputNumber
                      step={(record.multiplo) ? record.multiplo : 1}
                      min={(record.cantidadminima) ? record.cantidadminima : 1}
                      maxLength='6' 
                      value={record.cantidad}
                      onChange={(value) => this.onChangeQty(record, value)}
                      onKeyDown={function (e) {
                        const regex = /^[0-9]{0,6}$/;
                        if (!regex.test(e.key)) {
                          e.preventDefault();
                        }
                    }}
                  />
                </td>
                <td width={70}>
                  <Tooltip title={this.renderDiscount(record.descuento)}>
                    <PercentageOutlined />
                  </Tooltip>
                  <Divider type={'vertical'} />

                  {record.observaciones && <Tooltip title={record.observaciones}>
                    <BookOutlined />
                  </Tooltip>}
                </td>
                <td width={100}>
                  <DisplayAmount amount={record.precioFinal} currency={record.moneda} />
                </td>
                <td width={40} rowSpan={1}>
                  <a style={{paddingBottom: 50}}  onClick={() => { this.onRemoveItem(record) }}>
                    <Tooltip title={<Trans>Remove product</Trans>}>
                      <DeleteFilled />
                    </Tooltip>
                  </a>
                </td>
              </tr>
              <tr>
                <td colSpan={6}>{record.descripcion}</td>
              </tr>
              </tbody>
            </table>
        )
      }
    ];
  }

  componentDidMount() {
    if (!this.props.changeQuotation && this.state.isClient) {
      this.props.getCurrentQuotation();
    } else {
      this.setState(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.quotation && this.state.isClient) {
      this.props.getCurrentQuotation();
    }
  }

  renderDiscount = (descuentos) => {
    let result = ''
    // Check if descuentos is not null (offline)
    if (descuentos) {
      descuentos.forEach(descuento => {
        const tmpdesc = descuento.replace(/(\.\d{2})\d*/, "$1") ;
        result = ( result == '' ) ? tmpdesc : result.concat(', ', tmpdesc);
      });
    }
    return result;
  }

  onClose = () => {
    this.props.setShowEstimate(false);
  }

  onTypeItemCode = (itemCode) => {
    this.setState({ itemCode })
  }

  onAddItem = () => {
    if (this.state.itemCode) {

      this.props.addItemQuotationFromCode({
        cotizacionId: this.props.quotation.id,
        code: this.state.itemCode,
        quantity : this.state.canItem,
      })

      this.setState({ itemCode: '', canItem:1 });
    }
  }

  onChangeQty = (record, value) => {

    const { t } = this.props;

    const minimum = record.cantidadminima | 1
    const multi = record.multiplo | 1

    if (minimum > value) {
      if (value) message.error(t('quantity-min', { min: minimum }) );
    } else if ((value % multi) > 0) {
      if (value) message.error(t('multiple-num', { cant: multi }) );
    } else {
      this.props.changeItemQuantityQuotation({
        cotizacionId: this.props.quotation.id,
        codigodearticulo: record.codigodearticulo,
        quantity: parseInt(value)
      })
    }

  }

  onInputChange = (type, value) => {
    const newState = { ...this.state }
    newState.quotation[type] = value;
    this.setState(newState)

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      this.props.setDataToQuotation({
        cotizacionId: this.props.quotation.id,
        type,
        value
      })

    }, 2000)

  }

  onDateChange = (date) => {
    const { setDataToQuotation, quotation } = this.props

    const data = {
      cotizacionId: quotation.id,
      type: 'fecha_validez',
      value: date && date.format(apiDateFormat)
    }

    setDataToQuotation(data)

  }

  onSave = () => {
    this.props.saveQuotation({
      cotizacionId: this.props.quotation.id,
    })
  }

  onNew = () => {
    this.props.newQuotation()
  }

  onRemoveItem = (item) => {
    this.props.removeItemFromQuotation({
      cotizacionId: this.props.quotation.id,
      codigodearticulo: item.codigodearticulo
    })
  }

  onDelete = () => {
    this.props.cancelQuotation({
      cotizacionId: this.props.quotation.id,
    })
  }

  onDeleteIntention = () => {
    const { t } = this.props;
    Modal.confirm({
      iconType: 'exclamation-circle',
      title: t('Delete quotation'),
      content: t('Do you wish to delete the quotation?'),
      okText: t('Confirm'),
      cancelText: t('Cancel'),
      onOk: this.onDelete,
    });
  }

  
  showDetail(data) {
    this.setState({ item: data });
    this.props.getProductByCode({ codigodearticulo: data.codigodearticulo })
  }

  render() {
    const { itemCode, canItem } = this.state
    const { t, quotation, isMobile } = this.props
    let qty = 0;
    let total = 0;
    let created
    let modified
    let dateValid

    if (quotation) {
      quotation.productos.forEach((item,i) => {
        qty += item.cantidad
        total += item.precioFinal
        quotation.productos[i].index = i;
      });
      created = moment(quotation.createdAt).format(dateFormat)
      modified = moment(quotation.updatedAt).format(dateFormat)
      dateValid = moment(quotation.fecha_validez).format(dateFormat)
    }

    return (
      <div style={{minWidth:350}}>
          {quotation && <div>
            { isMobile && <Col span={24}  style={{textAlign:'right', paddingRight:'10px'}} >
              <CloseOutlined onClick={this.onClose}/>
            </Col>}
            <div className="name-input">
              <FormItem {...formItemLayout} label="Referencia">
                <Input onChange={(event) => this.onInputChange('referencia', event.target.value)} value={quotation.referencia} />
              </FormItem>
            </div>

            <div className="name-input">
              <FormItem {...formItemLayout} label="Producto">
                <Row gutter={8}>
                  <Col span={14}>
                    <Input onChange={(event) => this.onTypeItemCode(event.target.value)} value={itemCode} />
                  </Col>
                  <Col span={6}>
                      <InputNumber min={1} value={canItem} onChange={ value => this.setState({ canItem : value }) }  />
                  </Col>
                  <Col span={4} >
                    <Button onClick={this.onAddItem}>
                      <PlusOutlined/>
                    </Button>
                  </Col>
                </Row>

              </FormItem>
            </div>
            <div className="name-input">
              <FormItem {...formItemLayout} label={t('Valid until')}>
                <DatePicker
                  id="fecha_validez"
                  format={dateFormat}
                  disabledDate={(current) => {
                    return moment().add(-1, 'days')  >= current;
                    }}
                  name="fecha_validez"
                  defaultValue={moment(quotation.fecha_validez)}
                  onChange={(value) => {
                    this.onDateChange(value);
                  }}
                  allowClear={false}
                />
              </FormItem>
            </div>

            <Table
              columns={this.columns}
              dataSource={quotation.productos}
              pagination={false}
              className="quick-cart-table"
              locale={{
                emptyText: t('No products'),
              }}
              rowKey={'codigodearticulo'}
            />

            <div className="totals">
              <div>{t('Total units')} {qty}</div>
              <div>{t('Total')} <DisplayAmount amount={total} /></div>
            </div>

            <div className="name-input" style={{ marginBottom: 10 }}>
              <TextArea
                placeholder={t('Observations')}
                rows={4}
                onChange={event => this.onInputChange('observaciones', event.target.value)}
                value={quotation.observaciones}
              />
            </div>

            <div className="info" >
              <div>{t('Created') + ':'} {created}</div>
              <div>{t('Last modified') + ':'} {modified}</div>
            </div>

            <div className="actions">
              <Tooltip title={t('New quotation')}>
                <PlusCircleOutlined style={{fontSize: 20}} onClick={this.onNew} />
              </Tooltip>
              <Tooltip title={t('Save quotation')} >
                <SaveFilled style={{fontSize: 20}} onClick={this.onSave} />
              </Tooltip>
              <Tooltip title={t('Cancel quotation')} >
                <CloseCircleFilled style={{fontSize: 20}} onClick={this.onDeleteIntention} />
              </Tooltip>
              <Link href={{ pathname: '/catalog/printQuotation', query: { id: this.props.quotation.id } }}>
                  <a target={'_blank'} >
                      <Tooltip title={t('Print view')}>
                          <PrinterOutlined />
                      </Tooltip>
                  </a>
              </Link>
            </div>
          </div>}
      </div>
    );
  }
}

const mapStateToProps = ({ catalog, quotation, auth }) => {
  const { current, changeQuotation } = quotation;

  return {
    showEstimate: catalog.showEstimate,
    quotation: current,
    changeQuotation,
    auth
  };
};



export default connect(mapStateToProps, {
  setShowEstimate,
  getCurrentQuotation,
  addItemQuotationFromCode,
  changeItemQuantityQuotation,
  removeItemFromQuotation,
  setDataToQuotation,
  saveQuotation,
  cancelQuotation,
  getProductByCode,
  newQuotation
})(withTranslation()(CatalogEstimateForm));
